export enum PrefixSimplified {
    TEMPO_TERMINOLOGY = 'TEMPO_TERMINOLOGY',
    TEMPO_VALIDATION = 'TEMPO_VALIDATION',
}

export type PrefixSimplifiedType = keyof typeof PrefixSimplified

export enum Prefix {
    XTRF_PROJECTS = 'XTRF_PROJECTS',
    XTRF_QUOTES = 'XTRF_QUOTES',
    MEMSOURCE = 'MEMSOURCE',
    TEMPO = 'TEMPO',
    TEMPO_QUOTES = 'TEMPO_QUOTES',
}

export type PrefixProjectType = keyof typeof Prefix

export type PrefixType = keyof typeof Prefix | keyof typeof PrefixSimplified
